import React from 'react';
import styles from './ScoreCircle.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const ScoreCircle = ({
  run,
  circleName,
  ringMaskName,
  ringShadowName,
  ringFillName,
  targetColor,
  initialDigits,
  initialLabel,
  digitsID,
  labelID
}) => {
  return (
    <div className={cx('score-wrapper', run && 'run')}>
      <svg width='164' height='164' viewBox='0 0 164 164' xmlns='http://www.w3.org/2000/svg'
           xmlnsXlink='http://www.w3.org/1999/xlink'>
        <defs>
          <filter id='innerShadowLarge' x0='-50%' y0='-50%' width='200%' height='200%'>
            <feFlood fill-color='black' />
            <feComposite in2='SourceAlpha' operator='out' />
            <feGaussianBlur stdDeviation='4' />
            <feOffset dx='0' dy='0' result='offsetblur' />
            <feFlood floodColor='#000000' floodOpacity='0.3' result='color' />
            <feComposite in2='offsetblur' operator='in' />
            <feComposite in2='SourceAlpha' operator='in' />
            <feMerge>
              <feMergeNode in='SourceGraphic' />
              <feMergeNode />
            </feMerge>
          </filter>
          <filter id='innerShadowSmall' x0='-50%' y0='-50%' width='200%' height='200%'>
            <feFlood fill-color='black' />
            <feComposite in2='SourceAlpha' operator='out' />
            <feGaussianBlur stdDeviation='2' />
            <feOffset dx='0' dy='0' result='offsetblur' />
            <feFlood floodColor='#000000' floodOpacity='0.3' result='color' />
            <feComposite in2='offsetblur' operator='in' />
            <feComposite in2='SourceAlpha' operator='in' />
            <feMerge>
              <feMergeNode in='SourceGraphic' />
              <feMergeNode />
            </feMerge>
          </filter>
          <filter id='ringFillDropShadow' x='-50%' y='-50%' width='200%' height='200%' filterUnits='objectBoundingBox'>
            <feMorphology radius='1' operator='dilate' in='SourceAlpha' result='shadowSpreadOuter1' />
            <feOffset in='shadowSpreadOuter1' result='shadowOffsetOuter1' />
            <feGaussianBlur stdDeviation='1' in='shadowOffsetOuter1' result='shadowBlurOuter1' />
            <feColorMatrix values='0 0 0 0 0.4179   0 0 0 0 0.4158   0 0 0 0 0.42  0 0 0 1 0' in='shadowBlurOuter1' />
          </filter>
        </defs>
        <g fill='none' fillRule='evenodd'>
          <circle className={cx(circleName)} cx='82' cy='82' r='70' fill={targetColor} filter='url(#innerShadowLarge)' />
          <path
            d='M82,164 C127.287349,164 164,127.287349 164,82 C164,36.7126505 127.287349,0 82,0 C36.7126505,0 0,36.7126505 0,82 C0,127.287349 36.7126505,164 82,164 Z M82,160 C125.07821,160 160,125.07821 160,82 C160,38.9217895 125.07821,4 82,4 C38.9217895,4 4,38.9217895 4,82 C4,125.07821 38.9217895,160 82,160 Z'
            fill='#EAE9EB' filter='url(#innerShadowSmall)'
          />
          <mask id={ringMaskName} fill='#FFFFFF'>
            <path d='M82,164 C127.287349,164 164,127.287349 164,82 C164,36.7126505 127.287349,0 82,0 C36.7126505,0 0,36.7126505 0,82 C0,127.287349 36.7126505,164 82,164 Z M82,160 C125.07821,160 160,125.07821 160,82 C160,38.9217895 125.07821,4 82,4 C38.9217895,4 4,38.9217895 4,82 C4,125.07821 38.9217895,160 82,160 Z' />
          </mask>
          <circle
            className={cx(ringShadowName)}
            cx='82' cy='82' r='80' stroke='#000000' strokeWidth='4' strokeLinecap='round'
            strokeDasharray='501,501' strokeDashoffset='130' transform='rotate(-89 82 82)'
            filter='url(#ringFillDropShadow)' mask={`url(#${ringMaskName})`}
          />
          <circle
            className={cx(ringFillName)}
            cx='82' cy='82' r='80' stroke={targetColor} strokeWidth='4' strokeLinecap='round'
            strokeDasharray='501,501' strokeDashoffset='130' transform='rotate(-89 82 82)'
          />
        </g>
      </svg>
      <div id={digitsID} className={cx('score-digits')}>{initialDigits}</div>
      <div id={labelID} className={cx('score-label')}>{initialLabel}</div>
    </div>
  );
};

export default ScoreCircle;



// WEBPACK FOOTER //
// ./src/app/components/molecules/ScoreCircle/ScoreCircle.js